import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { winnersQueryKeys } from '@/data/services/querykeys';
import Hackathon from '@/models/Hackathon';
import { getWinnersCount } from '@/utils/hackathon';
import { UseQueryOptions } from '@tanstack/react-query';
import { groupBy } from 'lodash';
import useListService from '../useListService';

export default function useWinners(
  hackathon?: Hackathon,
  options: Pick<UseQueryOptions, 'enabled'> = {},
) {
  const winnersCount = getWinnersCount();

  const {
    results: winners,
    isInitialLoading: isLoading,
    invalidate,
  } = useListService({
    enabled: !!hackathon && options.enabled,
    staleTime: REQUEST_STALE_TIME_IN_MS,
    structuralSharing: false,
    ...winnersQueryKeys.list({
      hackathonId: hackathon?.id,
      pageSize: winnersCount,
    }),
  });

  let winnersByCategory = groupBy(winners, 'category');

  const winnersByRank = groupBy(winners, 'rank');

  winnersByCategory = Object.fromEntries(
    Object.entries(winnersByCategory).map(([category, projects]) => [
      category,
      projects.sort((a, b) => {
        const rankOrder: Record<string, number> = { '2': 1, '1': 2, '3': 3 };
        return (rankOrder[a.rank] || 3) - (rankOrder[b.rank] || 3);
      }),
    ]),
  );

  return { winners, winnersByCategory, winnersByRank, isLoading, invalidate };
}
